// Libraries
import styled from 'styled-components'

// Components
import { Aligner } from 'heeds-ds'

export const AbsoluteContainer = styled.div`
  bottom: 1rem;
  position: absolute;
  right: 1.6rem;
`

export const RelativeContainer = styled(Aligner)`
  position: relative;
`
